module.exports = __webpack_public_path__ + "static/media/swift-file-icon.8cca9e42.svg";